// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"107":"c6e07143","166":"49b18377","242":"8bb957a0","560":"61737d31","927":"41b2bbfe"}[chunkId] + ".css";
};